import React, { useEffect, useState } from 'react'
import '../auth.css'
import OTPInput from 'react-otp-input'
import { useTranslation } from 'react-i18next'
import { formatTimer } from 'utils/helperFunction'
import { SET_AUTH_LOADER } from '../../../redux/types'
import { AppUseDispatch, AppUseSelector } from '../../../redux/hooks'
const OtpSection = ({
  otp,
  setOtp,
  setOtpError,
  onClick,
  btnTitle,
  handleBackClick,
  timer,
  handleResend,
  otpError,
  email,
  isHidden,
  setIsHidden,
  hideSubmit,
}: {
  otp: string
  setOtp: (otp: string) => void
  setOtpError?: (err: string | null) => void
  setIsHidden?: (isHidden: boolean) => void
  onClick: () => void
  btnTitle: string
  otpError?: string | null
  handleBackClick: () => void
  isHidden?: boolean
  timer?: number
  resendCount?: number
  MAX_RESEND_ATTEMPTS?: number
  handleResend?: () => void
  verifyCount?: number
  MAX_VERIFY_ATTEMPTS?: number
  email?: string
  /**
   * Drop the submit button. The code submits itself as soon as the sixth digit
   * lands (see the effect below), so where the surrounding flow continues on
   * its own the button is a control that never needs pressing.
   */
  hideSubmit?: boolean
}) => {
  const { t } = useTranslation('auth')
  const dispatch = AppUseDispatch()
  const { authLoader } = AppUseSelector(({ user }) => user)
  const [hasSubmitted, setHasSubmitted] = useState(false)

  const maskEmail = (email: string) => {
    if (!email) return ''
    const [username, domain] = email.split('@')
    if (!username || !domain) return email

    if (username.length <= 2) {
      return `${username.charAt(0)}*@${domain}`
    } else {
      const maskedUsername = username.charAt(0) + '*'.repeat(username.length - 2) + username.charAt(username.length - 1)
      return `${maskedUsername}@${domain}`
    }
  }

  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (otp.length === 6 && !hasSubmitted) {
      onClick()
      dispatch({ type: SET_AUTH_LOADER, payload: true })
    }
     if (otp.length < 6) {
      setHasSubmitted(false)
    }
  }

  useEffect(() => {
    if (otp.length === 6 && !hasSubmitted) {
      setHasSubmitted(true)
      onClick()
      dispatch({ type: SET_AUTH_LOADER, payload: true })
    } 
    if (otp.length < 6) {
      setHasSubmitted(false)
    }
  }, [otp])

  return (
    <div className='otp-form-div'>
      <div className='otp-form-back-arrow-div' onClick={handleBackClick}>
        <img src={'/images/icons/back-arrow.svg'} alt={t('otp.backIconAlt')} />
        <span>{t('otp.back')}</span>
      </div>
      <p className='otp-form-email-text'>{t('otp.enterCode', { email: maskEmail(email || '') })}</p>
      <form onSubmit={handleFormSubmit}>
        <div className='otp-form-flex-div'>
          <div className='form-group mb-0'>
            <OTPInput
              value={otp}
              onChange={(value) => {
                setOtpError?.(null)
                setIsHidden?.(true)
                setOtp(value)
              }}
              numInputs={6}
              inputType='tel'
              shouldAutoFocus
              renderSeparator={<span style={{ width: '8px' }}></span>}
              inputStyle={{
                borderRadius: '8px',
                width: '54px',
                height: '50px',
                fontSize: '15px',
                color: '#000',
                fontWeight: '400',
                caretColor: 'blue',
              }}
              // react-otp-input labels each box "Please enter OTP character N" in English.
              renderInput={(props, index) => (
                <input
                  {...props}
                  aria-label={t('otp.digitLabel', { number: index + 1, count: 6 })}
                  className='form-input-2 w-input'
                  name='full-name-2'
                />
              )}
            />
          </div>
        </div>
        {hideSubmit ? (
          authLoader ? <p className='otp-sec-text'>{t('pleaseWait')}</p> : null
        ) : (
          <button type='submit' className='button-2 green-btn-class w-button w-100' disabled={authLoader}>
            {authLoader ? t('pleaseWait') : btnTitle}
          </button>
        )}
        {typeof timer === 'number' && typeof formatTimer === 'function' ? (
          timer > 0 ? (
            <p className='otp-sec-text'>{t('otp.sendAgainIn', { time: formatTimer(timer) })}</p>
          ) : (
            <span
              className='otp-sec-text'
              style={{
                display: 'block',
                textAlign: 'center',
                marginTop: 8,
                cursor: 'pointer',
                fontWeight: 350,
                pointerEvents: timer > 0 ? 'none' : 'auto',
                opacity: timer > 0 ? 0.5 : 1,
              }}
              role='button'
              tabIndex={0}
              aria-disabled={timer > 0}
            >
              {otpError && <span style={{ color: '#E36256' }}>{otpError}</span>}{' '}
              {isHidden ? null : (
                <span onClick={handleResend} style={{ textDecoration: 'underline', color: '#222525' }}>
                  {t('otp.sendAgain')}
                </span>
              )}
            </span>
          )
        ) : null}
      </form>
    </div>
  )
}

export default OtpSection
